module.exports = __webpack_public_path__ + "9b03c1c4de57c09852eef5d3d39edd66.svg";